var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("KTextbox", {
    ref: "textbox",
    attrs: {
      value: _vm.value,
      disabled: _vm.$attrs.disabled,
      label: _vm.coreString("fullNameLabel"),
      autofocus: _vm.$attrs.autofocus,
      maxlength: 120,
      invalid: Boolean(_vm.shownInvalidText),
      invalidText: _vm.shownInvalidText,
      autocomplete: _vm.$attrs.autocomplete,
    },
    on: {
      blur: function ($event) {
        _vm.blurred = true
      },
      input: function ($event) {
        return _vm.$emit("update:value", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }